import type { LaunchDarklyFeature } from "@/dto/merchant";

type MerchantFeatureFlags = {
  launchDarklyFeatures?: LaunchDarklyFeature[] | null;
};

/** Returns true only when the merchant has the named LD flag enabled. */
export const hasMerchantFeatureFlag = (
  merchant: MerchantFeatureFlags | null | undefined,
  flagName: string
): boolean =>
  Boolean(
    merchant?.launchDarklyFeatures?.some(
      (feature) => feature.name === flagName && feature.enabled
    )
  );
